<div class="status-container" [class.show]="message">
  <div class="details-container" [class.show-details]="show">
    <div class="spinner" [class.spinner-animate]="processing">
      <span></span>
    </div>
    <div class="message-container">
      <p>{{ message | translate }}</p>
      @if (navigationContext) {
        <a (click)="onLinkClick()">{{ navigationContext.caption | translate }}</a>
      }
    </div>
  </div>
  <div class="action-btn-container">
    <button class="btn" type="button" (click)="onClick()">
      @if (processing) {
        <span class="pointer" [class.pointer-hide]="!show"></span>
      }
      @if (!processing) {
        <span class="close">+</span>
      }
    </button>
  </div>
</div>
